import * as React from "react";
import { Agentation } from "agentation";

export function wrapRootElement({ element }) {
  return (
    <>
      {element}
      {process.env.NODE_ENV === "development" && <Agentation />}
    </>
  );
}
